import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
//import "../../dist/css/modules/observer-animations.min.css";

gsap.registerPlugin(ScrollTrigger);

const observedElements = document.querySelectorAll("[data-observe]");
const enterEvent = new Event("gsapenter");

export default function observe() {
  observedElements.forEach((element) => {
    element.classList.add("is-below");
    element.gsapFrom = gsap.from(element, {
      scrollTrigger: {
        start: "top bottom-=20px",
        trigger: element,
        onEnter: function () {
          element.classList.add("has-been-seen");
          element.classList.add("is-in-view");
          element.classList.remove("is-below");
          element.dispatchEvent(enterEvent);
        },
        onLeave: function () {
          element.classList.remove("is-in-view");
          element.classList.add("is-above");
          element.classList.remove("is-below");
        },
        onEnterBack: function () {
          element.classList.add("is-in-view");
          element.classList.remove("is-above");
          element.classList.remove("is-below");
        },
        onLeaveBack: function () {
          element.classList.remove("is-in-view");
          element.classList.add("is-below");
        },
      },
    });
  });
}

export function refreshObservedChildren(parent) {
  if (
    Object.hasOwn(parent, "gsapFrom") &&
    Object.hasOwn(parent.gsapFrom, "scrollTrigger")
  ) {
    parent.gsapFrom.scrollTrigger.refresh();
  }
  parent.querySelectorAll("[data-observe]").forEach((observedElement) => {
    if (
      Object.hasOwn(observedElement, "gsapFrom") &&
      Object.hasOwn(observedElement.gsapFrom, "scrollTrigger")
    ) {
      observedElement.gsapFrom.scrollTrigger.refresh();
    }
  });
}
